export default __webpack_public_path__ + "static/media/InertiaImg.54eeb659.jpg";